<template>
  <v-dialog v-model="isVisible" persistent max-width="600px">
      <v-card>
          <v-toolbar dense :color="$store.state.UiColors.crudToolbarList">
              <v-icon>list</v-icon>
              <v-toolbar-title class="font-weight-light">{{label}}</v-toolbar-title>
              <v-spacer></v-spacer>
              </v-toolbar>

              <v-data-table 
              :headers="headers"
              :items="items"
              :server-items-length="totalItems"
              :rows-per-page="pagination.rowsPerPage"
              :items-per-page-options="pagination.rowsPerPageItems"
              :options.sync ="pagination"
              v-model="selectedRow"
              :loading="loading"
              >
              <template slot="no-data">
                  <v-alert :value="true" color="grey" icon="warning">
                  No se encontraron resultados
                  </v-alert>
              </template>
              <template v-slot:item="{ item }">                        
                  <tr>
                      <template v-for="header in headers">
                        <td class="text-xs-left">{{ item[header.value] }}</td>
                      </template>
                      
                      <td class="justify-center layout px-0">
                        <v-icon @click="setSelectedItem(item), isVisible = false">check_circle_outline</v-icon>
                      </td>
                  </tr>
              </template>
          </v-data-table>
          <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="isVisible = false">Cerrar</v-btn>
          </v-card-actions>
      </v-card >
  </v-dialog>

</template>
<script>

import Vue from 'vue'
import { http } from '@/axios'
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data: () => ({
    loading: false,
    
    pagination: { // definición de paginación
      sortDesc:[false],
      sortBy:[''],       
      page: 1,
      itemsPerPage: 5,
      rowsPerPageItems:[5,10,20]
    }, 
    totalItems: 0, // va afuera de pagination    
    selectedRow: [],
    items: []
  }),
  props: {        
    label: {
      type: String,
      default: 'Búsqueda de'
    },
    iconName: {
      type: String,
      default: 'home'
    },
    headers: {
      type: Array,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    searchApi: {
      type: String,
      required: true
    },
    searchFor: {
      type: String,
      required: true
    },
    setSelectedItem: Function,    
    notFound: Function,    
  },    
  watch:{      
      pagination :{
        handler(){
          this.search();
        },
        deep: true
    },
    visible:{
      handler(){         
        if(this.visible)
          this.search();
      }
    }    
  },
  computed:{
    isVisible: {
      get: function(){
        return this.visible
      },
      set: function (value){
        this.$emit('update:visivility', value )
      }
    }
  },
  methods:{
    ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
    async search(){
      try {
        if(!this.isVisible)
          return;

        var result = await http.get(this.searchApi +'?' + this.searchFor + '&limit=' + this.pagination.itemsPerPage + '&page=' + this.pagination.page); // traigo todas

        this.items = result.list;
        this.totalItems = result.totalCount

        if(this.totalItems == 0){
            // avisar que no se encontró
            this.alertWarning("No se encontraron registros con los datos ingresados.");
            await this.notFound();
            this.isVisible = false; 
        }
        else if(this.totalItems == 1){
            // setear directamente
            await this.setSelectedItem(result.list[0]);
            this.isVisible = false;                
        }
      } catch (error) {
          // Error        
          this.alertWarning(error)
      }

    }
  }
}
</script>

